import { AbstractControl, ValidatorFn } from "@angular/forms";
export const numberDecimalFormatValidator = (maxValue: number): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;

        const valueString = String(maxValue);
        const valueSeparate = valueString.split(".");

        const valueInt = valueSeparate[0];
        const valueDec = valueSeparate[1];

        const regexString = `/^[0-9]{1,${valueInt.length}}(\.[0-9]{1,${valueDec.length}})?$/`;

        const regexN = new RegExp(regexString);
  
        const isValidFormat = regexN.test(value);
        const numericValue = parseFloat(value);

        return !isValidFormat && (numericValue > maxValue) ? { 'numberFormat': true } : null;
    }
}